import tw from 'tailwind-styled-components'

export const TwInputContainer = tw.div<{
  $hasError?: boolean
}>`
  flex
  items-center
  h-32 
  rounded-4 
  bg-input-old
  border 
  border-solid
  ${p =>
    p.$hasError
      ? 'border-error-old'
      : 'border-main-old focus-within:border-action-default'} 
  outline-none
`

export const TwInput = tw.input`
  p-0 
  bg-input-old
  border-none 
  outline-none 
  w-full 
  text-14
  text-main-old
  disabled:text-obscure-old
  disabled:bg-input-old
`
